// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { createContext, useContext, type ReactNode, type ReactElement } from 'react';

// Etiket düzenleme bağlamı — UI package, aktif entity için bu değeri sağlar.
// Renderer'lar (FieldShell/DenseField/DetailRenderer/ListRenderer başlığı) bunu okur,
// düzenleme açıkken etiket yanında ✏️ gösterir. Bağlam yoksa hiçbir şey değişmez (geri uyum).
export interface LabelEditContextValue {
  /** Düzenleme modu açık mı (header'daki kalem toggle'ı) */
  readonly editing: boolean;
  /** Kullanıcı firma kapsamında da düzenleyebilir mi (firm_admin) */
  readonly canEditFirm: boolean;
  /** Bir alanın etiketini düzenle — UI bir popover açar, kaydeder, metadata'yı tazeler */
  readonly onEdit?: (fieldName: string, currentLabel: string) => void;
}

const LabelEditContext = createContext<LabelEditContextValue>({ editing: false, canEditFirm: false });

export function LabelEditProvider({ value, children }: { value: LabelEditContextValue; children: ReactNode }): ReactElement {
  return <LabelEditContext.Provider value={value}>{children}</LabelEditContext.Provider>;
}

export function useLabelEdit(): LabelEditContextValue {
  return useContext(LabelEditContext);
}
